import moment from 'moment';
import { camelizeKeys } from 'humps';

class Order {
  static createOrderFromWarehouseResponse ({ whOrder = {} } = {}) {
    const whOrderCamelized = camelizeKeys(whOrder);
    return new Order({
      id: whOrderCamelized.id,
      createdAt: whOrderCamelized.createdAt,
      numberOfItems: whOrderCamelized.itemCount,
      orderNumber: whOrderCamelized.orderNumber,
      status: whOrderCamelized.status,
      tag: whOrderCamelized.displayName || whOrderCamelized.tag,
      total: whOrderCamelized.total
    });
  }

  /** Creates a new order instance with optional overrides. */
  constructor (overrides) {
    this.fields = { ...overrides };
  }

  /** Creates a new design copied from this with optional overrides. */
  makeCopy (overrides) {
    return new Order({ ...this.fields, ...overrides });
  }

  // =======
  // GETTERS
  // =======
  /** Returns the id for this order. */
  id () { return this.fields.id; }

  isStarting () { return this.status() === 0; }

  orderNumber () { return this.fields.orderNumber; }

  numberOfItems () { return this.fields.numberOfItems; }

  numberOfItemsFormatted () {
    const numberOfItems = this.numberOfItems();
    const pluralization = numberOfItems !== 1 ? 's' : '';
    return `${numberOfItems} item${pluralization}`;
  }

  status () { return this.fields.status; }

  type () {
    const tag = this.fields.tag;

    switch (tag) {
      case 'Product Purchase':
        return 'Product Order';
      case 'Furniture Order':
        return 'Product Order';
      default:
        return tag;
    }
  }

  total () { return parseFloat(this.fields.total); }

  totalFormatted () {
    return this.total().toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  createdAt () { return this.fields.createdAt; }

  createdAtFormatted () {
    const date = moment(this.createdAt());
    return date.format('MMM D, YYYY');
  }
}

export default Order;
